import { Component, OnInit, EventEmitter, Output, Renderer2 } from '@angular/core';
import templateString from './allocationRequestTypeClone.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString
})
export class AllocationRequestTypeCloneComponent implements OnInit {
    @Output() action = new EventEmitter();

    public currentSchedulePeriodId: any;
    public allocationRequestTypesCurrentSchedulePeriod: any;

    public isLoading;
    public checkAll: boolean;
    public schedulePeriods: any;
    public selection: any = {};
    public allocationRequestTypes: any;
    
    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

	refresh() {
        var self = this;
        this.http.get("allocation_request_types", { params: { schedule_period_id: this.selection.schedulePeriodId } }).subscribe((x) => {
        	this.allocationRequestTypes = x;
			this.allocationRequestTypes.forEach(function(allocationRequestType) {
				allocationRequestType.alreadyExistsInCurrentSchedule = self.allocationRequestTypesCurrentSchedulePeriod.filter(function(x) { return x.name == allocationRequestType.name; }).length > 0;
				allocationRequestType.checkForClone = allocationRequestType.alreadyExistsInCurrentSchedule;
			});
			
			this.isLoading = false;
		});
	}
	
	changeSchedulePeriod() {
		this.isLoading = true;
		this.refresh();
	}	
	
	checkAllForClone() {
        var self = this;
		this.allocationRequestTypes.filter(function(x) { return !x.alreadyExistsInCurrentSchedule; }).forEach(function(allocationRequestType) {
			allocationRequestType.checkForClone = self.checkAll;
		});
	}	

    ok() {
        this.isLoading = true;
        this.http.post("allocation_request_types/clone", { 
			current_schedule_period_id: this.currentSchedulePeriodId, 
			allocation_request_type_ids: this.allocationRequestTypes
				.filter(function(x) { return x.checkForClone && !x.alreadyExistsInCurrentSchedule; })
				.map(function(x) { return x.id; })
        }).subscribe(() => {
            this.isLoading = false;

            this.action.emit(true);
			this.bsModalRef.hide();
		});
    };

    cancel() {
        this.bsModalRef.hide();
    };

    ngOnInit() {
        this.isLoading = true;
        this.checkAll = false;
        
        this.http.get("schedule_periods").subscribe((schedulePeriods) => {
            this.schedulePeriods = schedulePeriods;
            
            var currentSchedulePeriodIndex = this.schedulePeriods.map(function(x) { return x.id }).indexOf(this.currentSchedulePeriodId);
            
            // get previous schedule period
            if (currentSchedulePeriodIndex > 0) {
                this.selection = { schedulePeriodId: this.schedulePeriods[currentSchedulePeriodIndex-1].id };
                
                this.refresh();
            } else {
                this.isLoading = false;
            }
        })
    }
}


